var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('b-row',{staticClass:"py-3"},[_c('b-col',[_c('h1',[_vm._v("Provisionslog")])])],1),_c('b-row',{staticClass:"py-3"},[_c('b-col',[_c('provisionslogtabelle')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }